import "./DadosBancarios.css";

const DadosBancarios = ({ DadosBancarios }) => {
  return (
    <div className="card shadow-sm p-4 mb-4 dados-bancarios">
      <h5 className="fw-bold text-uppercase mb-4">
        Dados Bancários do Sindicato
      </h5>

      <div className="row">
        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Tipo de Conta</label>
          <input
            type="text"
            className="form-control"
            value={
              DadosBancarios?.tipoContaDescricao ||
              DadosBancarios?.tipoConta ||
              DadosBancarios?.tipo ||
              ""
            }
            readOnly
          />
        </div>
        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Banco</label>
          <input
            type="text"
            className="form-control"
            value={DadosBancarios?.banco || ""}
            readOnly
          />
        </div>
        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Agência</label>
          <input
            type="text"
            className="form-control"
            value={DadosBancarios?.agencia || ""}
            readOnly
          />
        </div>
        <div className="col-md-3 mb-3">
          <label className="form-label fw-semibold">Conta</label>
          <input
            type="text"
            className="form-control"
            value={DadosBancarios?.conta || ""}
            readOnly
          />
        </div>
      </div>

      <p className="text-muted small mt-2 fst-italic">
        Caso necessário alteração dos dados, favor entrar com contato com a
        Superintendência de Desenvolvimento Sindical.
      </p>
    </div>
  );
};

export default DadosBancarios;
